export default __webpack_public_path__ + "static/media/25.33a2c91d.png";